import {fadeIn, fadeOut} from "../helpers/animation";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const toggle = () => {
  if(window.innerWidth >= 1024) return;

  document.addEventListener('DOMContentLoaded', () => {
    const buttonOpen = document.querySelector('.js-filter-open');
    const buttonClose = document.querySelector('.js-filter-close');
    const body = document.querySelector('.js-filter-body');
    const classActive = 'filter__button--active';

    if(!buttonOpen) {
      return;
    }

    const openFilter = () => {
      buttonOpen.classList.add(classActive)
      fadeIn(body);
      disableBodyScroll(document);
    }

    const closeFilter = () => {
      buttonOpen.classList.remove(classActive);
      fadeOut(body);
      clearAllBodyScrollLocks();
    }

    buttonOpen.addEventListener('click', openFilter)
    buttonClose.addEventListener('click', closeFilter)
  });
}

toggle();





